var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/register/steps/RegisterMinorAccountInfo.tsx";
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Footer, Form, Header, Input, InputPassword, LogoActionBar, Main, PasswordInputValidator, ScrollContainer, Spinner } from 'Components/utility';
import { PhoneInput } from 'Components/utility/PhoneInput';
import { REGISTER } from 'Reducers/register/types';
import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
import { store } from 'Utilities/store';
const mapStateToProps = ({
  config: {
    validation
  }
}) => {
  return {
    validation,
    leadingTrailingSpacesIdentity: validation?.identity.find(identity => identity.data.key === 'leadingTrailingSpaces')
  };
};
const connector = connect(mapStateToProps);
const RegisterMinorAccountInfo = ({
  back,
  values: currentValues,
  handleSubmitRegister,
  loading,
  validation,
  leadingTrailingSpacesIdentity,
  currentStep
}) => {
  const showPhoneInput = currentValues.country === 'US';
  const [meetsPasswordRequirements, setMeetsPasswordRequirements] = useState(false);
  const validationSchema = Yup.object().shape({
    email: Yup.string().email(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.errors.emailAddressValidEmail')).required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.errors.required')),
    password: leadingTrailingSpacesIdentity ? Yup.string().matches(new RegExp(leadingTrailingSpacesIdentity.data.regex), i18n.t(`Login.content.signInForm.formField.password.helpText.${leadingTrailingSpacesIdentity.data.key}`)) : Yup.string(),
    confirmPassword: Yup.string().oneOf([Yup.ref('password')], i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.errors.confirmPasswordMustMatch')).required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.errors.required'))
  });
  const onSubmit = useCallback(async (values, {
    setSubmitting
  }) => {
    try {
      setSubmitting(true);
      const register = {
        ...currentValues,
        ...values,
        currentStep
      };
      store.dispatch({
        type: REGISTER,
        register
      });
      await handleSubmitRegister(register);
    } catch (err) {
      log.error(err);
    } finally {
      setSubmitting(false);
    }
  }, [currentStep, currentValues, handleSubmitRegister]);
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    isValid,
    isSubmitting,
    errors,
    touched,
    values
  } = useFormik({
    initialValues: {
      ...currentValues
    },
    validationSchema: validationSchema,
    onSubmit,
    validateOnBlur: true
  });
  const handleOnBack = useCallback(() => {
    back({
      ...values,
      password: '',
      confirmPassword: ''
    });
  }, [back, values]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LogoActionBar, {
    actionButtonTestID: "CreateAccountAccountInfo.action-go-back",
    titleTestID: "CreateAccountAccountInfo.actionTitle",
    title: i18n.t('CreateAccountAccountInfo.title'),
    onBack: handleOnBack,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 7
    }
  }), loading && /*#__PURE__*/React.createElement(Spinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    titleTestID: "CreateAccountAccountInfo.title",
    subtitleTestID: "CreateAccountAccountInfo.subtitle",
    title: i18n.t('CreateAccountAccountInfo.title'),
    subtitle: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.primaryText'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Form, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 156,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.label'),
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoFormMinor.formField.parentEmail.label'),
    errorMessage: errors.email,
    isInvalid: errors.email && touched.email ? true : false,
    testID: "email",
    value: values.email,
    onChangeText: handleChange('email'),
    onBlur: handleBlur('email'),
    inputMode: "email",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 11
    }
  }), showPhoneInput && /*#__PURE__*/React.createElement(PhoneInput, {
    "aria-label": i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    errorMessage: errors.phoneNumber,
    isInvalid: errors.phoneNumber && touched.phoneNumber ? true : false,
    testID: "phoneNumber",
    value: values.phoneNumber,
    onChangeText: handleChange('phoneNumber'),
    onBlur: handleBlur('phoneNumber'),
    maxLength: 15,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 176,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(PasswordInputValidator, {
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.label'),
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue,
    handleBlur: handleBlur('password'),
    onChangeText: handleChange('password'),
    password: values.password,
    onValidate: setMeetsPasswordRequirements,
    identities: validation?.identity,
    testID: "password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 192,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(InputPassword, {
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.label'),
    isInvalid: errors.confirmPassword && touched.confirmPassword ? true : false,
    errorMessage: errors.confirmPassword,
    testID: "confirmPassword",
    onBlur: handleBlur('confirmPassword'),
    onChangeText: handleChange('confirmPassword'),
    value: values.confirmPassword,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 209,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.links.next.label'),
    buttonTestID: "CreateAccountAccountInfo.nextButton",
    onButtonSubmit: handleSubmit,
    isButtonDisabled: !values.email || !values.password || !values.confirmPassword || !isValid || isSubmitting || !meetsPasswordRequirements,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 225,
      columnNumber: 7
    }
  }));
};
export default connector(RegisterMinorAccountInfo);